import React, { useState, useEffect } from "react";
import Axios from "axios";
import { isMobile } from "react-device-detect";
import BigCLoading from "../components/Loading";

async function addLineUser(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/line_user/line_save",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      }
    );

    if (result.data.status == "success") {
      return result.data.data;
    } else {
      return { message: "failed" };
    }
  } catch (error) {
    console.log(`bigc-line-coupon-web: addLineUser : ${error}`);
    return { message: "failed" };
  }
}


const Ecatalog = () => {
  const liff = window.liff;
  useEffect(async () => {
    async function fetchData() {
      const allPathName = window.location.pathname;
      const pathName = allPathName.substring(11); // out --> /e-catalog
      const searchParam = window.location.search;
      //console.log(pathName);
      //console.log(searchParam);

      // แปลง query string เป็น object
      const urlParams = new URLSearchParams(searchParam);

      // ดึงค่าของ utm_source และ utm_medium
      const utmSource = urlParams.get('utm_source');
      const utmMedium = urlParams.get('utm_medium');
      const utmCampaign = urlParams.get('utm_campaign');

        liff
          .init({
            liffId: process.env.REACT_APP_CDP_LIFF_ID, // Use own liffId
          })
          .then(() => {
            // start to use LIFF's api
            if (liff.isLoggedIn()) {
              //console.log('isLoggedIn');
              const getProfile = liff.getProfile();
              //setLineProfile(getProfile);
              getProfile
                .then((profile) => {
                  //console.log(profile);
                  const userId = profile.userId;
                  const displayName = profile.displayName;
                  //const statusMessage = profile.statusMessage;
                  const pictureUrl = profile.pictureUrl;
                  //const email = liff.getDecodedIDToken().email;
    
                  const payload = {
                    line_id: userId,
                    utm_source : utmSource,
                    utm_medium : utmMedium,
                    utm_campaign : utmCampaign
                  };
                  console.log(payload);
    
                  const res = addLineUser(payload)
                    .then(async (data) => {
                      console.log(data);
                      /*if (data.message != "failed") {
                        await AddSession(data);
                        if (sessionStorage.getItem("accessToken")) {
                          window.location.href = "/coupons-list";
                        }
                      }*/
                    })
                    .catch((err) => {
                      console.log("error", err);
                    });
                })
                .catch((err) => {
                  console.log("error", err);
                });
            } else {
              //console.log('login');
              liff.login();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      

        //window.location.href = `https://bigc-online-catalog.web.app/catalog/${pathName}${searchParam}`;
    }
    //   https://bigc-line-liff-redirect.web.app/line-connect?feature=register&utm_source=Standee_Store&utm_medium=organic&utm_campaign=>PV:DMK>DA:20240726>AN:->OB:VIEW>FM:Photo>FT:Line_Connect_Menu>CN:crm_campaign>PT:Line_Connect
    //   localhost:3001/line-connect?feature=register&utm_source=Standee_Store&utm_medium=organic&utm_campaign=>PV:DMK>DA:20240726>AN:->OB:VIEW>FM:Photo>FT:Line_Connect_Menu>CN:crm_campaign>PT:Line_Connect
    fetchData();
  }, []);
  return <></>;
};

export default Ecatalog;
